import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ProfileService } from '../../../services/profile.service';
import {Module, AllCommunityModules } from '@ag-grid-community/all-modules';
import { EditButtonRendererComponent } from '../../../renderer/edit-button-renderer.component';
import { DeleteButtonRendererComponent } from '../../../renderer/delete-button-renderer.component';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { ConstantService } from '../../../services/constant.service';
import { ApiService } from '../../../services/api.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

import * as data from './../../../../assets/data/data.json';
import { Papa } from 'ngx-papaparse';
import { ValidateCsvService } from '../../../services/validateCsv.service';
import { Md5 } from 'ts-md5/dist/md5';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html'
})
export class ProfileComponent implements OnInit {
  @ViewChild('newProfile') public newProfile: ModalDirective;
  @ViewChild('deleteProfileModal') public deleteProfileModal: ModalDirective;
  @ViewChild('updateProfileModal') public updateProfileModal: ModalDirective;
  @ViewChild('deleteBulkComplainModal') public deleteBulkComplainModal: ModalDirective;
  public gridApi;
  public gridColumnApi;
  public modules: Module[] = AllCommunityModules;
  public context;
  public frameworkComponents;
  public defaultColDef;
  public columnDefs;
  private permission;
  public selectedColony = [];

  public rowSelection;
  _ = _;
  public userTypeList: any = [
    {typeCode: 'admin', permission: 'rwmd'},
    {typeCode: 'staff', permission: 'r'}
  ]
  usersList = [];
  departments = [];
  newProfileForm = {
    username: '',
    fullName: '',
    userType: '',
    password: '',
    permission : '',
    contactNo: ''
  }

  alert = {
    type: 'info',
    msg: '',
    timeout: 5000
  }
  dropdownList = [];
  selectedItems = [];
  dropdownSettings: IDropdownSettings = {};
  constructor(private profileService: ProfileService, private constantService:  ConstantService, private apiService: ApiService, private papa: Papa, private validateCsvService: ValidateCsvService) {

    this.permission = this.constantService.getCookies().PERMISSION;
    let permissionArray = this.permission.split('')
    this.context = { componentParent: this };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      flex:1,
      resizable: true,
      floatingFilter: true,
    };
    this.frameworkComponents = {
      editButtonRenderer: EditButtonRendererComponent,
      deleteButtonRenderer : DeleteButtonRendererComponent
    };

    this.rowSelection = 'multiple';

    this.columnDefs = [
      { headerName: 'Srl No', field: 'srl_no', width: 60, filter: false, resizable: false,
      checkboxSelection: true,},
      { headerName: 'Employee Id', field: 'employee_id', width: 150 },
      { headerName: 'Username', field: 'username', width: 150 },
      { headerName: 'Full Name', field: 'fullName', width: 150 },
      { headerName: 'Contact No', field: 'contactNo', width: 150 },
      { headerName: 'Read', field: 'read', width: 60, resizable: false,
      cellRenderer: params => {
          return `<input type='checkbox' ${params.value ? 'checked' : ''} disabled />`;
      }},
      { headerName: 'Write', field: 'write', width: 60, resizable: false,
      cellRenderer: params => {
          return `<input type='checkbox' ${params.value ? 'checked' : ''} disabled />`;
      } },
      { headerName: 'Modify', field: 'modify', width: 60, resizable: false,
      cellRenderer: params => {
          return `<input type='checkbox' class="disabled" ${params.value ? 'checked' : ''} disabled />`;
      } },
      { headerName: 'Delete', field: 'delete', width: 60 ,resizable: false,
      cellRenderer: params => {
          return `<input type='checkbox' ${params.value ? 'checked' : ''} disabled />`;
      }}
    ];

    // if (_.includes(permissionArray, 'd')) {
    //   this.columnDefs.push({ headerName: 'Edit', field: 'value', cellRenderer: 'editButtonRenderer', colId: 'params',  width: 60, filter: false, resizable: true, sortable: false, pinned: 'right',cellClass: ['text-center']  },
    //   { headerName: 'Delete', field: 'value', cellRenderer: 'deleteButtonRenderer', colId: 'params1',  width: 60, filter: false, resizable: true, sortable: false, pinned: 'right',cellClass: ['text-center']  },
    //   )
    // }
   }

  ngOnInit(): void {

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    // this.departments = this.profileService.getDepartment();
    // console.log(this.departments);
    this.listUser();
    this.getDataConstant();
  }
  listUser() {
    let queryString = "users.*, employees.employee_id FROM users, employees WHERE users.username = employees.phone_no";
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: []) => {
      _.each(resp, (user) => {
        if(user.permission) {
          let permission = (user.permission).split('');
          if (_.includes(permission, 'r')) {user['read'] = true} else {user['read'] = false};
          if (_.includes(permission, 'w')) {user['write'] = true} else {user['write'] = false};
          if (_.includes(permission, 'm')) {user['modify'] = true} else {user['modify'] = false};
          if (_.includes(permission, 'd')) {user['delete'] = true} else {user['delete'] = false};
        }

        // console.log(permission);
      })
      this.usersList = resp;
      // console.log(this.usersList);
    })
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  selectedUser: any = {};
  methodFromParent(userData) {
    this.selectedUser = userData;
    console.log(this.selectedUser, userData.action);
    if(userData.action === 'edit') {
      this.newProfileForm = _.clone(this.selectedUser);

      this.updateProfileModal.show();
    }
    if(userData.action === 'delete') {
      this.deleteProfileModal.show();
    }


  }

  saveNewProfile() {
    // this.newProfileForm.sectors = ((this.selectedItems).map(item => item.item_text)).join(',');
    this.newProfileForm['dateTime'] = moment().format('YYYY-MM-DD HH:mm:ss');
    let username = this.newProfileForm.contactNo;
    this.newProfileForm.password = btoa('user@'+username.slice(username.length - 4));
    console.log('user@'+username.slice(username.length - 4))
    if (this.newProfileForm.userType === 'admin') { this.newProfileForm.permission = 'rwmd'; }
    if (this.newProfileForm.userType === 'staff') { this.newProfileForm.permission = 'r'; }
    let userType = _.find(this.userTypeList, (user) => user.typeCode === this.newProfileForm.userType);
    if (userType && userType.typeCode) {
      this.newProfileForm.permission = userType.permission;
    }
    this.newProfileForm.username = this.newProfileForm.contactNo;
    let that = this;
    this.profileService.createProfile(this.newProfileForm).subscribe((resp) => {
      console.log(resp);
      that.resetForm();
      that.listUser();
      that.alert.msg = 'Profile has been successfully created.';
      setTimeout(() => {
        that.newProfile.hide();
        that.alert.msg = '';
      }, 2000)
    })
  }

  selectUserType(type) {
    if(type !== 'department') {
    }
  }
  resetForm() {
    this.newProfileForm = {
      username: '',
      fullName: '',
      userType: '',
      password: '',
      permission : '',
      contactNo: '',
    }
    this.selectedColony = [];
  }
  deleteProfile() {
    this.apiService.deleteDetail('users', 'srl_no', [this.selectedUser.srl_no]).subscribe((resp) => {
      this.listUser();
      setTimeout(() => {
        this.deleteProfileModal.hide();
        this.alert.msg = '';
      }, 1000)
    })
  }
  multipleItemForDelete: any[] = [];
  askTodeleteMultipleItem() {
    this.multipleItemForDelete = this.gridApi.getSelectedRows();
  }
  deletingLoader = false;
  deleteMultiple() {
    this.deletingLoader = true;
    let deleteItem = (this.multipleItemForDelete).map((row) => row.srl_no);
    console.log(deleteItem);
    this.apiService.deleteDetail('users', 'srl_no', deleteItem).subscribe((resp) => {
      this.listUser();
      this.deletingLoader = false;
      this.deleteBulkComplainModal.hide();
      this.alert.msg = '';
    })
  }

  updateProfile() {
    let payload = {
      fullName: this.newProfileForm.fullName,
      contactNo: this.newProfileForm.contactNo,
      userType: this.newProfileForm.userType,
      permission: ''
    };
    // payload.sectors = ((this.selectedItems).map(item => item.item_text)).join(',');
    if (this.newProfileForm.userType === 'admin') { payload.permission = 'rwmd'; }
    if (this.newProfileForm.userType === 'staff') { payload.permission = 'r'; }
    let userType = _.find(this.userTypeList, (user) => user.typeCode === this.newProfileForm.userType);
    if (userType && userType.typeCode) {
      this.newProfileForm.permission = userType.permission;
    }
    let that = this;
    this.profileService.updateProfile(this.selectedUser.srl_no, payload).subscribe((resp) => {
      console.log(resp);
      that.resetForm();
      that.listUser();
      that.alert.msg = 'Profile has been successfully updated.';
      setTimeout(() => {
        that.updateProfileModal.hide();
        that.alert.msg = '';
      }, 2000)
    })
  }

  bulkUpload() {

  }
  onItemSelect(e) {
  }
  onItemDeSelect(e) {
  }
  onSelectAll(items: any) {
    console.log(items);
  }
  getDataConstant() {
    console.log((data as any).default.employee_document)
  }




  @ViewChild('fileImportInput') fileImportInput: ElementRef;
  private entry_operator_id = "";


  csvHeaderFields = ["employee_id","full_name","work_location","designation","salary","phone_no","email_id", "project", "qualification", "father_name", "date_of_joining", "aadhar_no"];
  // csvHeaderFields = ["userType","username","password","fullName","contactNo","permission","project"];
  isHeader: any = false;
  csvErrorMsg: any = null;
  isCsvBlank: any = false;
  records = {
    recordsUploaded: 0,
    totalRecords: 0,
    progress: 0
  };
  patientDetailClone: any = {};
  flag = {
    enableSave: false
  }


  csvRecords: any[] = [];
  rawCsv = null;
  header = true;
  csvContent: string;
  formattedData = [];
  loadCsvFile($event: any) {
    // Select the files from the event
    const files = $event.srcElement.files;
    let that = this;
    if (files && files.length > 0) {
      let file: File = files.item(0);
      let reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e) => {
        that.rawCsv = reader.result as string;
        //  console.log(that.rawCsv);
        that.parseCSV();
      }
    }

  }

  parseCSV() {
    let that = this;
    let options = {
      header: true,
      complete: (results, file) => {
        console.log('Parsed: ', results);
        that.csvRecords = results.data;
        that.validateCSV(that.csvRecords, results.meta.fields);
      }
    }
    this.papa.parse(this.rawCsv, options);
  }


  // table_header = "(userType,username,password,project,fullName,contactNo,permission)";
  table_header = "(employee_id,full_name,work_location,designation,salary,phone_no,email_id,project,qualification,father_name,date_of_joining,aadhar_no)";

  generatePassword(phone_no){
    let password = btoa('user@'+phone_no.slice(phone_no.length - 4));

    const md5 = new Md5();
    return md5.appendStr(password).end();
  }

  convertBigInt(number) {
    console.log(number, +number);
    return +number;
  }

  validateCSV(csv, csvFields) {
    // console.log(csv)
    if (csv.length === 0) {
      this.isHeader = false;
      this.isCsvBlank = true;
      this.csvErrorMsg = {
        blank_error: 'CSV file must contain atleast 1 record'
      }
    } else {
      console.log(_.sortBy(this.csvHeaderFields), _.sortBy(csvFields))
      if (!_.isEqual(_.sortBy(this.csvHeaderFields), _.sortBy(csvFields))) {
        this.isHeader = false;
        this.isCsvBlank = false;
        let diff: string[] = _.difference(_.sortBy(this.csvHeaderFields), _.sortBy(csvFields));
        console.log(diff)
        this.csvErrorMsg = {
          header_required: 'CSV file must contain these header ' + diff.join(", ") + " or check spellings",
          // header_available: 'Existing CSV file contains header in format [' + csv[0] + ' ] ',
        };
      } else {
        this.isHeader = true;
        this.isCsvBlank = false;
        this.csvErrorMsg = {};
        _.each(this.csvRecords, (record) => {
          if(record['phone_no'] !== undefined && record['phone_no'] !== '') {
            this.formattedData.push("( '" + this.clean(record['employee_id']) + "', '" + this.clean(record['full_name']) + "', '" + this.clean(record['work_location']) + "', '" +
             this.clean(record['designation']) + "', '" + this.clean(record['salary']) + "', '" + this.clean(record['phone_no']) + "', '" + this.clean(record['email_id']) + "', '" + this.clean(record['project']) + "', '" +
             this.clean(record['qualification']) + "', '" + this.clean(record['father_name']) + "', '" + this.clean(record['date_of_joining']) + "', '" + this.clean(record['aadhar_no'])+ "' )");
            //  this.formattedData.push("( 'staff', '" + this.clean(record['phone_no']) + "', '" + this.generatePassword(record['phone_no'])+ "', '" + this.clean(record['project']) + "', '" +
            //  this.clean(record['full_name']) + "', '" + this.clean(record['phone_no']) + "', 'rwm' )");
          }
        })
        console.log(this.formattedData);
        this.flag.enableSave = true;
      }
    }
  };

  clean(str) {
    if (str) {
      return (_.trim(str.replace(/[^\w\s]/g, '')));
    } else {
      return str;
    }

  }
  csvUpload() {
    let that = this;
    this.records.totalRecords = this.formattedData.length - 1;
    let chunkSize = 200;
    let chunkData = _.chunk(_.slice(this.formattedData, 0), chunkSize);
    this.records.recordsUploaded = 0;
    let i = 0;
    _.each(chunkData, (data) => {
      setTimeout((val) => {
        let payload = {
          header: btoa(unescape(encodeURIComponent(this.table_header))),
          data: btoa(unescape(encodeURIComponent(data)))
        }
        this.apiService.addBulkData('employees', payload).subscribe((response) => {
          that.records.recordsUploaded = that.records.recordsUploaded + data.length;
          console.log(that.records.recordsUploaded + " - " + that.records.totalRecords);
          console.log((that.records.recordsUploaded * 100) / that.records.totalRecords);
          that.records.progress = (that.records.recordsUploaded * 100) / that.records.totalRecords;
        })
      }, i * 3000);
      i++;

    })
  }

  resetUpload() {
    this.fileImportInput.nativeElement.value = '';
    this.records = {
      recordsUploaded: 0,
      totalRecords: 0,
      progress: 0
    };
    this.csvRecords = [];
    this.csvContent = '';
    this.formattedData = [];
    this.csvErrorMsg = {};
    // this.selectedVehicleId = '';
    // this.selectList.nativeElement.value = 'Select Vehicle';
  }


}
